import BaseService from './BaseService';

class UserService extends BaseService {
  /**
   * Constructor
   * @return {undefined}
   */
  constructor() {
    super();

    this.config = {
      ...this.config,
      method: 'post',
    };
  }


  /**
   * Login
   * @param  {Object} creds
   * @return {Promise}
   */
  login = (creds = {}) => {
    const config = {
      url: '/login',
      data: {
        accessCodeName: creds.accessCodeName,
        email: creds.emailAddress,
        password: creds.password,
      },
    };
    return this.doRequest(config);
  };

  /**
   * Fetch the user's info
   * @return {Promise}
   */
  fetchUser = () => {
    const config = {
      url: 'login/user',
      method: 'get',
    };
    return this.doRequest(config);
  };

  /**
   * Facebook Login
   * @param  {Object} data
   * @return {Promise}
   */
  facebookLogin = (data) => {
    const config = {
      url: '/facebook/processsignedrequest',
      data,
    };
    return this.doRequest(config);
  };


  /**
   * Google login
   * @param  {String} token
   * @return {Promise}
   */
  googleLogin = (token) => {
    const config = {
      method: 'post',
      url: '/google/callback',
      data: token,
    };
    return this.doRequest(config);
  };


  /**
   * Logout
   * @return {Promise}
   */
  logout = () => {
    const config = {
      url: '/login/logout',
    };
    return this.doRequest(config);
  };
}

export { UserService as default };